<div #container
  [ngClass]="{'ui-dropdown ui-widget ui-state-default ui-corner-all rich-dropdown':true,
            'ui-state-disabled':disabled, 'ui-dropdown-open':overlayVisible, 'ui-dropdown-clearable': showClear && !disabled}"
  (click)="onMouseclick($event)" [ngStyle]="style" [class]="styleClass">
  <div class="ui-dropdown-label-container">
    <span
      [ngClass]="{'ui-dropdown-label ui-inputtext ui-corner-all':true,'ui-dropdown-label-empty':(label == null || label.length === 0)}"
      *ngIf="label != null">
      {{label||'empty'}}
    </span>
    <span
      [ngClass]="{'ui-dropdown-label ui-inputtext ui-corner-all ui-placeholder':true,'ui-dropdown-label-empty': (placeholder == null || placeholder.length === 0)}"
      *ngIf="label == null">{{placeholder||'empty'}}</span>
    <i class="ui-dropdown-clear-icon fa fa-times" (click)="clear($event)"
      *ngIf="value != null && showClear && !disabled"></i>
  </div>
  <div class="ui-dropdown-trigger ui-state-default ui-corner-right" role="button">
    <span class="ui-dropdown-trigger-icon ui-clickable"
      [ngClass]="overlayVisible?dropdownExpandedIcon:dropdownCollapsedIcon"></span>
  </div>
</div>